import { useEffect, useState } from "react";
import { customStyles } from "../../../components/Modal/ModalComponent";
import Modal from 'react-modal';
import Button from "../../../components/Button/Button";
import { IoClose } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import { slugify } from "../../../utils/string";
import RoleService from "../../../services/RolesService";
import { useAuth } from "../../../contexts/auth";
import { FiUserPlus } from "react-icons/fi";
import ToolTip from "../../../components/Tooltip/Tooltip";

export function RoleSelector(props) {
   const [modalIsOpen, setModalIsOpen] = useState(false);
   const navigate = useNavigate();
   const [roles, setRoles] = useState([]);
   const [searchText, setSearchText] = useState('');
   const [isLoading, setIsLoading] = useState(true);
   const { user } = useAuth();
   const clientData = user.userData.selectedOrganizationId ?? 1;

   const getRoles = async (page, searchText, clientID, orderBy) => {
      try {
         setIsLoading(true);
         const response = await RoleService.getPaginated(
            page,
            searchText,
            clientID,
            orderBy
         );
         if (response && response.data) {
            const paginated = response.data;
            setRoles(paginated.items);
         }
      } catch (error) {
         console.error(error);
      } finally {
         setIsLoading(false);
      }
   };

   useEffect(() => {
      if (!modalIsOpen) return;
      getRoles(1, searchText, clientData.id, { collumnTitle: 'name', orderDirection: 'ASC' });
   }, [user, clientData.id, searchText, modalIsOpen]);

   return (
      <>
         <Button
            className="button-blue adicionar-button"
            action="add"
            label="Adicionar Pessoa"
            onClick={() => setModalIsOpen(true)}
         />

         <Modal
            isOpen={modalIsOpen}
            onRequestClose={() => setModalIsOpen(false)}
            style={{
               ...customStyles,
               content: {
                  ...customStyles.content,
                  width: '650px',
                  maxWidth: '90dvw',
                  padding: '36px'
               }
            }}
            contentLabel="Adicionar Pessoa"
         >
            <div className='modal-header'>
               <h2>Escolha o perfil da pessoa</h2>
               <button className="close-button" onClick={() => setModalIsOpen(false)}><IoClose /></button>
            </div>
            <div className='modal-body'>
               {isLoading ? (
                  <div className="flex text-left w-full text-(--textColor) h-full animate-pulse transform-none!">
                     Buscando perfis disponíveis...
                  </div>
               ) : (
                  <div className='buttons-reader-model-wrapper grid grid-cols-4 gap-2.5'>
                     {roles?.map(role => (
                        <button className='button-reader-model min-h-[80px]' type="button" key={role.id} onClick={() => navigate(`../perfil/${role.externalId}/cadastro-operadores/`)}>
                           <span className="text-base!">{role.name}</span>
                        </button>
                     ))}
                  </div>
               )}
               <div className="inline-flex items-center gap-2 mt-3!">
                  <Link to={`../cadastro-operadores`} className="inline-flex w-fit items-center text-(--textColor) gap-2! underline! hover:opacity-60 duration-200">
                     <FiUserPlus size={16} />
                     Cadastrar permissões manualmente
                  </Link>
                  <ToolTip
                     contentClassName={`w-[260px]!`}
                     tooltipVisible={true}
                     tooltipText={`Cadastrar uma nova pessoa e adicionar as permissões do usuário cloud, deste novo cadastro, manualmente.`}
                  />
               </div>
            </div>
         </Modal>
      </>
   );
}